import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { updateUserEmployerBusinessIdResourcesFromOrientationForm } from '../services/update-user-employer-business-id-resources-from-orientation-form.service';

/**
 * Thunk to update user employer business ID resources.
 * @param {Object} params - Parameters for the update.
 * @param {string} params.businessId - employer business ID.
 * @param {string} params.userId - ID of the user whose resources are to be updated.
 * @param {Object} params.updates - The updates to be applied to the resources.,
 * @returns {Object} - All updated resources.
 */
export const setUpdateUserEmployerBusinessIdResourcesFromOrientationForm = createAsyncThunk(
  'users/setUpdateUserEmployerBusinessIdResourcesFromOrientationForm',
  async (params, { getState }) => {
    const state = getState();
    const selectedProjectId = selectSelectedProjectId(state);

    const _params = {
      ...params,
      projectId: selectedProjectId
    }

    const updatedResources = await updateUserEmployerBusinessIdResourcesFromOrientationForm(_params);

    return updatedResources;
  }
);